'use strict';

require('../../style/index.less');

require('./index.less');

require('../../radio/style');

require('../../checkbox/style');

require('../../dropdown/style');

require('../../spin/style');

require('../../pagination/style');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/table/style/index.js
// module id = 40
// module chunks = 0